import { render, staticRenderFns } from "./window-primary.vue?vue&type=template&id=45ce8ecc&scoped=true&"
import script from "./window-primary.vue?vue&type=script&lang=js&"
export * from "./window-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ce8ecc",
  null
  
)

export default component.exports